import { ChangeDetectionStrategy, Component, inject, signal, viewChild } from '@angular/core';
import { ChatComponent } from './chat/chat.component';
import { MatTab, MatTabGroup, MatTabLabel } from '@angular/material/tabs';
import { IconComponent } from '@gains-com/ui-angular';
import { FriendsListComponent } from './friends-list/friends-list.component';
import { ShellService } from '../shell.service';

@Component({
  selector: 'app-right-sidenav',
  templateUrl: './right-sidenav.component.html',
  styleUrl: './right-sidenav.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ChatComponent, MatTabGroup, MatTab, IconComponent, MatTabLabel, FriendsListComponent],
})
export class RightSidenavComponent {
  private readonly _shell = inject(ShellService);

  readonly rightSidenavTabGroup = viewChild<MatTabGroup>('rightSidenavTabGroup');

  selectedTabIndex = signal(0);

  constructor() {
    // Seed the initial tab selection (Friends) on the shell subjects. Tab
    // changes are pushed from the (selectedIndexChange) handler below rather
    // than synced via an effect.
    this._syncTabSelection(this.selectedTabIndex());
  }

  onSelectedTabChange(index: number) {
    this.selectedTabIndex.set(index);
    this._syncTabSelection(index);
  }

  private _syncTabSelection(index: number) {
    const friendsTabSelected = index === 0;
    this._shell.rightSidenavFriendsTabSelected$.next(friendsTabSelected);
    this._shell.rightSidenavChatTabSelected$.next(!friendsTabSelected);
  }
}
